import React, { useContext } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { RenderModule } from 'holocron';
import { getDates } from '../../selectors/requestSelectors';
import { setDates } from '../../ducks/requestDuck';
import {
  dateErrorSelector,
  getIsErrorByField,
} from '../../selectors/validationSelectors';
import HotelsContext from '../../context/hotelsContext';
import { DATE_FORMAT } from '../../constants/dateConstants';
import ThemeContext from '../../context/themeContext';
import { DATE_PICKER_MODULE_NAME } from '../../constants/globalConstants';

const HotelDateRange = () => {
  const { formatMessage } = useIntl();
  const isStartDateWarning = useSelector(getIsErrorByField('startDate'));
  const isEndDateWarning = useSelector(getIsErrorByField('endDate'));
  const dateErrors = useSelector(dateErrorSelector(formatMessage));
  const dateValues = useSelector(getDates);
  const dispatch = useDispatch();
  const onChange = (dates) => dispatch(setDates(dates));

  const theme = useContext(ThemeContext);
  const {
    config: {
      minNights,
      maxNights,
      minAdvanceBooking,
      maxAdvanceBooking,
      isMosaicDesign = false,
    },
  } = useContext(HotelsContext);

  const datePickerProps = {
    isDateRange: true,
    value: dateValues,
    onChange,
    placeholder: {
      startDate: formatMessage({ id: 'check-in' }),
      endDate: formatMessage({ id: 'check-out' }),
    },
    minStartDate: dayjs().add(minAdvanceBooking, 'days').format(DATE_FORMAT),
    maxDaysAdvanceFromToday: maxAdvanceBooking,
    maxNights,
    minNights,
    theme,
    warnings: {
      isStartDateWarning,
      isEndDateWarning,
    },
    errors: dateErrors,
    isMosaicDesign,
  };

  return (
    <RenderModule
      moduleName={DATE_PICKER_MODULE_NAME}
      props={{
        id: 'hotelsStartDate',
        ...datePickerProps,
      }}
    />
  );
};

export default HotelDateRange;
